module.exports = __webpack_public_path__ + "assets/img/image_315.1e4fbbf1.png";